<irb-common-overlay #overlayComponent></irb-common-overlay>

<div class="dialog create-securities-dialog-component">  
  <div mat-dialog-title>Create New<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear" >clear</i></button></div>
  <mat-tab-group style="clear: both;" animationDuration="0ms" dynamicHeight [(selectedIndex)]="index">
    <mat-tab label="By Symbol/CUSIP">
      <ng-template matTabContent>
        <irb-create-securities-by-symbol-dialog [selectedOptionChainData]="optionChainData" (multiLineValues)="setMultiLineValues($event)">
        </irb-create-securities-by-symbol-dialog>
      </ng-template>
    </mat-tab>
    <mat-tab label="Option Chains" [disabled]="eventData && (eventData.editModel || eventData.editSecurity)">
      <ng-template matTabContent>
        <div style="padding: 10px;">   
            <irb-option-chains [optionChainData]="optionChainInput" (closeOptionChainDialog)="closeOptionChain($event)"></irb-option-chains>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Define a custom security" [disabled]="eventData && eventData.isHideCustomSecurity">
      <ng-template matTabContent>
        <irb-create-securities-by-custom-dialog></irb-create-securities-by-custom-dialog>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
